import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import TabSingleTextWrapper from '../../../../common/tabSingleTextWrapper';

const Phase1 = forwardRef(({ permissions: { disableEdit }, data }, ref) => {
  const {
    current: { phases, id: drugId, ingestedId },
    original: { phases: originalData },
    ingested: {
      phases: { data: ingestedData, fieldActions: ingestedActions },
    },
  } = useSelector(state => state.drugs, shallowEqual);
  return (
    <TabSingleTextWrapper
      disableEdit={disableEdit}
      footerData={data}
      data={phases}
      parentKey="phases"
      childKey="phaseI"
      drugId={drugId}
      ingestedId={ingestedId}
      originalData={originalData}
      ingestedData={ingestedData['phaseI']}
      ingestionAction={ingestedActions['phaseI']}
      parentIngestionAction={ingestedActions}
      ref={ref}
    />
  );
});

Phase1.propTypes = {
  permissions: PropTypes.object.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isTab: PropTypes.bool.isRequired,
    tabs: PropTypes.array.isRequired,
  }),
};

Phase1.displayName = 'Phase1';

export default Phase1;
